import { render, staticRenderFns } from "./clientesDetalles.vue?vue&type=template&id=73aaf6f0&"
import script from "./clientesDetalles.vue?vue&type=script&lang=js&"
export * from "./clientesDetalles.vue?vue&type=script&lang=js&"
import style0 from "./clientesDetalles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports